import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { RequestClinicComponent } from './request-clinic/request-clinic.component';
import { LeftNavComponent } from './left-nav/left-nav.component';
import { ContactComponent } from './contact/contact.component';
import { OrganisationComponent } from './organisation/organisation.component';
import { RouterModule, Routes } from '@angular/router';
import { ServicesComponent } from './services/services.component';
import { ClinicDetailsComponent } from './clinic-details/clinic-details.component';
import { BillingComponent } from './billing/billing.component';
import { ReviewDetailsComponent } from './review-details/review-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiInterceptor } from './api.interceptor';
import { ClinicSubmittedComponent } from './clinic-submitted/clinic-submitted.component';
import { MobileTopBarComponent } from './mobile-top-bar/mobile-top-bar.component';
import { LeftNavImgComponent } from './left-nav-img/left-nav-img.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GoogleAnalyticsService } from './DataLayer/google-analytics-service.service';
import { LoaderComponent } from './loader/loader.component';
import { DatePipe } from '@angular/common';
import { ModalComponent } from './modal/modal.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { AutoFocus } from './autofocus/autofocus';

// const appRoutes: Routes = [
//   // { path: 'contact', component: ContactComponent},
//   // { path: 'organisation', component: OrganisationComponent},
//   // { path: 'services', component: ServicesComponent},
//   // { path: 'clinic-details', component: ClinicDetailsComponent},
//   // { path: 'billing', component: BillingComponent},
//   // { path: 'review-details', component: ReviewDetailsComponent},
//   // { path: 'clinic-submitted', component: ClinicSubmittedComponent}
// ];

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        RequestClinicComponent,
        LeftNavComponent,
        ContactComponent,
        OrganisationComponent,
        ServicesComponent,
        ClinicDetailsComponent,
        BillingComponent,
        ReviewDetailsComponent,
        ClinicSubmittedComponent,
        MobileTopBarComponent,
        LeftNavImgComponent,
        LoaderComponent,
        ModalComponent,
        AutoFocus
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        AppRoutingModule,
        //RouterModule.forRoot(appRoutes),
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MatSelectModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        NgxMaskModule.forRoot()], providers: [
        GoogleAnalyticsService, DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
